import { Box, Text } from 'grommet';
import React, { useMemo, useState } from 'react';
import { FTSelect } from '../../../../components/inputs';

const CustomAdUnitTemplateSelector = ({
  customAdUnitTemplates,
  setSelectedTemplate,
  currentTemplate
}) => {
  const [templateId, setTemplateId] = useState(null);
  const [search, setSearch] = useState('');

  const validTemplates = useMemo(
    () =>
      customAdUnitTemplates.filter(template => template?.id && template?.name),
    [customAdUnitTemplates]
  );

  const filteredTemplates = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return validTemplates;
    return validTemplates.filter(template =>
      template.name.toLowerCase().includes(query)
    );
  }, [validTemplates, search]);

  const selectedTemplateId = templateId ?? currentTemplate;

  return (
    <>
      <Box margin={{ vertical: 'xsmall' }}>
        <Text size='xlarge' fill='horizontal'>
          <strong>ADMIN ONLY</strong>: Use a Partner Specific Testing Template
        </Text>
        <Text fill='horizontal'>
          These templates are intended for one-off partner specific use cases.
          The template have not been tested and approved for global use across
          our partner network.
        </Text>
      </Box>
      <Box width={{ min: '400px', max: '400px' }}>
        <FTSelect
          disabled={validTemplates.length === 0}
          title='Select a template'
          placeholder='Select a template'
          labelKey='name'
          valueKey='id'
          options={filteredTemplates}
          value={validTemplates.find(
            template => template.id === selectedTemplateId
          )}
          onChange={({ id }) => {
            setTemplateId(id);
            setSelectedTemplate(id);
          }}
          handleSearch={setSearch}
          onClose={() => setSearch('')}
        />
      </Box>
    </>
  );
};

export default CustomAdUnitTemplateSelector;
